$.fn.isInViewport = function() {

    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(window).on('resize scroll',function() {

    $('.dnJs-clickWhenVisible').each(function() {
        if ($(this).isInViewport()) {
            $(this).removeClass('dnJs-clickWhenVisible');
            $(this).click();
        }
    });
});